import {API} from '../../api/API';
import { USER_VERIFICATION_URL } from '../../config/config';

export const saveUserVerification = (verificationData,userVerificationSuccessHandler,userVerificationFailureHandler) => {
    console.log("Entering saveUserVerification");
    //replace {userId} with actual id
    let verificationURL = USER_VERIFICATION_URL.replace('userid',verificationData.userId)
    API.put(verificationURL, verificationData)
    .then(res => {
        userVerificationSuccessHandler(res.data)
    })
    .catch(err => {
        userVerificationFailureHandler(err);
        
    });
}